import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logo_moodconnect_white.png'
import _imports_1 from '../../assets/ig_icon.png'
import _imports_2 from '../../assets/li_icon.png'
import _imports_3 from '../../assets/fb_icon.png'
import _imports_4 from '../../assets/yt_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-cd424308"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "footer bottom-0 w-100"
}
const _hoisted_2 = { class: "pt-5 grid grid-cols-3 pl-4 pb-4" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div data-v-cd424308><div class=\"grid grid-cols-3\" data-v-cd424308><div class=\"help\" data-v-cd424308> Need help or have questions? <br data-v-cd424308>Contact us at <a href=\"mailto:info@moodconnectapp.com\" data-v-cd424308>info@moodconnectapp.com</a></div></div><div class=\"pl-2 col-span-3 md:col-span-1\" data-v-cd424308><div class=\"flex flex-col space-y-2\" data-v-cd424308><a href=\"https://www.moodconnect.com/\" target=\"_blank\" data-v-cd424308><img src=\"" + _imports_0 + "\" alt=\"MoodConnect\" class=\"w-40 -ml-5\" data-v-cd424308></a><div class=\"flex flex-row space-x-4 items-center\" data-v-cd424308><a href=\"https://www.instagram.com/moodconnect/\" target=\"_blank\" data-v-cd424308><img src=\"" + _imports_1 + "\" alt=\"Instagram\" class=\"w-6\" data-v-cd424308></a><a href=\"https://www.linkedin.com/company/moodconnect\" target=\"_blank\" data-v-cd424308><img src=\"" + _imports_2 + "\" alt=\"LinkedIn\" class=\"w-6\" data-v-cd424308></a><a href=\"https://www.facebook.com/moodconnect\" target=\"_blank\" data-v-cd424308><img src=\"" + _imports_3 + "\" alt=\"Facebook\" class=\"w-6\" data-v-cd424308></a><a href=\"https://www.youtube.com/channel/UCBAAxO8SJ1KzBOqEsW2f0mg\" target=\"_blank\" data-v-cd424308><img src=\"" + _imports_4 + "\" alt=\"YouTube\" class=\"w-6\" data-v-cd424308></a></div></div></div></div>", 1)
const _hoisted_4 = { class: "col-span-3 md:col-span-1 md:col-start-3" }
const _hoisted_5 = { class: "flex flex-col space-y-2 mt-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg" }, "Resources", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (!_ctx.msAppLoaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_router_link, {
                class: "text-sm",
                to: "/terms"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Terms and Conditions")
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                class: "text-sm",
                to: "/privacy"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Privacy Policy")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}